import { HTTP, authHeader } from './http-service';

class DataSubjectAccessRequestService {
  get(payload) {
    return HTTP.get(`/DataSubjectAccessRequest/${payload.dsarId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  create(payload) {
    return HTTP.post(`/DataSubjectAccessRequest`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  update(payload) {
    return HTTP.put(`/DataSubjectAccessRequest`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  listDataSubjectAccessRequestOwners() {
    return HTTP.get(`/DataSubjectAccessRequest/owners`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new DataSubjectAccessRequestService();
